// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"336":"advice","631":"service","697":"news"}[chunkId] || chunkId) + "." + {"73":"a56ed71f","109":"a56ed71f","126":"a56ed71f","156":"a56ed71f","162":"a56ed71f","336":"131cfdb1","408":"a56ed71f","485":"a56ed71f","538":"a56ed71f","631":"85e4c0e1","697":"f78d6e61","712":"a56ed71f"}[chunkId] + ".css";
};